<div class="styleWidget js--element-sWidget">
    <div class="styleWidget-trigger js--action-toggleStyleWidget"></div>
    <div class="styleWidget-main">
        <div class="styleWidget-main-hd">
            <div>Theme Settings</div>
            <div>
                <label class="styleWidget-main-hd-peristLabel" for="persistToggle">Persist Settings:</label>
                <input class="styleWidget-main-hd-persistToggle js--element-persistToggle" type="checkbox" {{#if savedSettingsPersist }}checked {{/if}}name="persistToggle" id="persistToggle">
            </div>
        </div>
        <ul class="styleWidget-main-current">
            <li>Set Brand Color: <span>{{ setBrandColor }}</span></li>
            <li>Set Logo: <span>{{ setLogoName }}</span></li>
            <li>Set Logo Secondary: <span>{{ setLogoSecondaryName }}</span></li>
            <li>Set Font Style: 
                <span>
                    {{#ifEquals setFontStyle 'default'}} Sans Serif{{/ifEquals}}
                    {{#ifEquals setFontStyle 'Playfair Display'}} Serif{{/ifEquals}}
                    {{#ifEquals setFontStyle 'Nunito'}} Rounded{{/ifEquals}}
                </span>
            </li>
            <li>Set Heading Size: <span>{{ setHeadingSize }}</span></li>
            <li>Set Heading Style: <span>{{#ifEquals setHeadingStyle 'Uppercase'}}All Caps{{ else }}{{ setHeadingStyle }}{{/ifEquals}}</span></li>
            <li>Set Theme Style: <span>{{ setThemeStyleName }}</span></li>
        </ul>
        <div class="styleWidget-main-setting">
            <div class="styleWidget-main-setting-color">
                <label for="brandColor">Brand Color:</label>
                <input class="js--element-brandColorPicker" type="color" name="brandColor" value="{{ setBrandColor }}" />
            </div>
            <div class="styleWidget-main-setting-logo">
                <label for="globalLogo">Upload Logo:</label>
                <input class="js--element-logoFileInput" type="file" name="globalLogo" />
            </div>
            <div class="styleWidget-main-setting-logo">
                <label for="globalSecondaryLogo">Upload Secondary Logo:</label>
                <input class="js--element-logoSecondaryFileInput" type="file" name="globalSecondaryLogo" />
            </div>
            <div class="styleWidget-main-setting-font">
                <label for="fontStyle">Font Style:</label>
                <select class="js--element-fontStyleSelect" name="fontStyle">
                    {{#each fontsList}}
                        <option {{#ifEquals this.value ../setFontStyle}}selected {{/ifEquals}}value="{{this.value}}">{{name}}</option>
                    {{/each}}
                </select>
            </div>
            <div class="styleWidget-main-setting-headings">
                <label for="hdgSize">Heading Size:</label>
                <select class="js--element-headingSizeSelect" name="hdgSize">
                    <option {{#ifEquals 'Large' setHeadingSize}}selected {{/ifEquals}}value="Large">Large (default)</option>
                    <option {{#ifEquals 'Medium' setHeadingSize}}selected {{/ifEquals}}value="Medium">Medium</option>
                    <option {{#ifEquals 'Small' setHeadingSize}}selected {{/ifEquals}}value="Small">Small</option>
                </select>
            </div>
            <div class="styleWidget-main-setting-headings">
                <label for="hdgStyle">Heading Style:</label>
                <select class="js--element-hdgStyleSelect" name="hdgStyle">
                    <option {{#ifEquals 'Uppercase' setHeadingStyle}}selected {{/ifEquals}}value="Uppercase">All Caps (default)</option>
                    <option {{#ifEquals 'Normal' setHeadingStyle}}selected {{/ifEquals}}value="Normal">Normal</option>
                </select>
            </div>
        </div>
        <div class="styleWidget-main-styles">
            <div class="styleWidget-main-styles-hd">Theme Style:</div>
            <ul class="styleWidget-main-styles-options js--element-themeStylePicker">
                <li class="{{#ifEquals setThemeStyleName "Light"}}isCurrent{{/ifEquals}}" data-theme-style-name="Light">Light</li>
                <li class="{{#ifEquals setThemeStyleName "Dark"}}isCurrent{{/ifEquals}}" data-theme-style-name="Dark">Dark</li>
                <li class="{{#ifEquals setThemeStyleName "Brand"}}isCurrent{{/ifEquals}}" data-theme-style-name="Brand">Brand</li>
                <li class="{{#ifEquals setThemeStyleName "Brand Contrast"}}isCurrent{{/ifEquals}}" data-theme-style-name="Brand Contrast">Brand Contrast</li>
            </ul>
        </div>
        <div class="styleWidget-main-actions">
            <button class="js--action-resetDefaults">Reset to defaults</button>
            <button class="js--action-toggleStyleWidget">Cancel</button>
            <button class="styleWidget-main-actions-save js--action-saveStyles">Save Settings</button>
        </div>
    </div>
</div>